module.exports = __webpack_public_path__ + "static/img/client3.0f6470c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/client3.jpg
// module id = 76
// module chunks = 1